import { UserActions } from 'BMapsCmds';
import { addMenuItem } from '../menu_cmds';

export default class DumpStateMenuItem {
    static Init() {
        addMenuItem('DumpState', 'Dump State', () => UserActions.DumpWorkspace());
    }
}
